<template>
    <div class="ui-bottom-sheet">
        <UiTeleport to="#app">
            <VueBottomSheetVue2
                ref="sheet"
                :max-height="maxHeight"
                :close-height-percent="closeHeightPercent"
                :can-swipe="draggable"
                :init-sheet-height="initSheetHeight"
                class="ui-bottom-sheet__wrapper"
                :style="{
                    zIndex,
                }"
                :overlay-color="overlayColor"
                @opened="localValue = true"
                @closed="localValue = false"
            >
                <slot />
            </VueBottomSheetVue2>
        </UiTeleport>
    </div>
</template>
<script>
import  VueBottomSheetVue2 from '@webzlodimir/vue-bottom-sheet-vue2';
import { onBeforeUnmount, onMounted, ref, watch, } from 'vue';
import UiTeleport from './UiTeleport.vue';

export default {
    name: 'UiBottomSheet',
    components: {
        VueBottomSheetVue2,
        UiTeleport,
    },
    props: {
        value: Boolean,
        draggable: {
            type: Boolean,
            default: true,
        },
        maxHeight: {
            type: Number,
            default: 800,
        },
        closeHeightPercent: {
            type: Number,
            default: 100,
        },
        zIndex: {
            type: Number,
            default: 99999,
        },
        overlayColor: String,
        initSheetHeight: Number,
    },
    setup(props, { emit }) {
        const localValue = ref(props.value);
        const sheet = ref(null);

        watch(() => props.value, (val) => {
            localValue.value = val;
        });

        const toggleSheet = (val) => {
            const sheetEl = sheet.value;
            if (!sheetEl) return;

            if (val === sheetEl.showSheet) return;

            if (val) {
                sheetEl.open();
            } else {
                sheetEl.close();
            }
        }

        watch(localValue, (val) => {
            toggleSheet(val);

            if (val === props.value) return;

            emit('input', val);
        });

        onMounted(async () => {
            toggleSheet(localValue.value);
        });

        const setHeight = () => {
            const height =  sheet.value.$refs.bottomSheetHeader.scrollHeight +
                            sheet.value.$refs.bottomSheetMain.scrollHeight +
                            sheet.value.$refs.bottomSheetFooter.scrollHeight;
            sheet.value.sheetHeight = props.maxHeight ? Math.min(props.maxHeight, height) : height;
        };

        // observe children changes for setting height
        const sheetMainObserverCb = () => {
            setHeight();
        };
        const observer = new MutationObserver(sheetMainObserverCb);
        watch(sheet, (sheet) => {
            const { bottomSheetMain, bottomSheetContent } = sheet?.$refs ?? {};

            // watch content changes
            if (bottomSheetMain) {
                observer.observe(bottomSheetMain, { attributes: false, childList: true, subtree: true });
            }

            // watch for sheet inner content img loaded
            if (bottomSheetContent) {
                bottomSheetContent.addEventListener('load', setHeight, { capture: true });
            }
        });

        onBeforeUnmount(() => {
            const { bottomSheetContent } = sheet.value?.$refs ?? {};
            observer.disconnect();
            bottomSheetContent.removeEventListener('load', setHeight, { capture: true });
        });

        return {
            localValue,
            sheet,
            toggleSheet,
        };
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/functions';
@import '../../assets/scss/base/mixins';

.ui-bottom-sheet {
    &__wrapper {
        color: $text-base;
    }
}
</style>
